
import { Vue, Options } from "vue-class-component";
import TimeSelector from "../components/TimeSelector.vue";
import DistanceSelector from "../components/DistanceSelector.vue";
import SplitSelector from "../components/SplitSelector.vue";
import PaceSelector from "../components/PaceSelector.vue";
import { Time } from "../models/time";
import * as timeUtil from "../models/time";
import { distanceUnits } from "../models/units";
@Options({
  components: { TimeSelector, DistanceSelector, PaceSelector, SplitSelector },
})
export default class Home extends Vue {
  private priv_distance = 0;
  private priv_distanceUnit = 1 / 1000;
  private priv_paceUnit = 1;

  private priv_splitDistance = 0;
  private priv_splitUnit = 1 / 1000;

  tableHasTooManyRows = false;

  distArray: number[] = [0];
  timeArray: Time[] = [{ hours: 0, minutes: 0, seconds: 0 }];

  splitPace: Time = { hours: 0, minutes: 0, seconds: 0 };

  private time: Time = { hours: 0, minutes: 0, seconds: 0 };
  private pace: Time = { hours: 0, minutes: 0, seconds: 0 };

  get shouldDisplayTable(): boolean {
    return (
      this.distance != 0 &&
      this.splitDistance != 0 &&
      (this.pace.hours != 0 || this.pace.minutes != 0 || this.pace.seconds != 0)
    );
  }
  stringifyNumber(number: number, shouldAddZero: boolean): string {
    if (number >= -9 && number <= 9 && shouldAddZero) {
      return "0" + number.toString();
    }
    return number.toString();
  }
  get splitUnitString(): string | undefined {
    return Object.keys(distanceUnits).find(
      (key) => distanceUnits[key] == this.splitUnit
    );
  }
  get splitDistance(): number {
    return this.priv_splitDistance;
  }

  set splitDistance(splitDistance: number) {
    this.priv_splitDistance = splitDistance;
    this.updateSplitpace();
  }
  get splitUnit(): number {
    return this.priv_splitUnit;
  }

  set splitUnit(splitUnit: number) {
    this.priv_splitUnit = splitUnit;
    this.updateSplitpace();
  }

  /*   stringifyTime(time: number): string {
    if (time >= -9 && time <= 9) {
      return "0" + time.toString;
    }
    return time.toString();
  } */
  get splitPaceSecondsString(): string {
    if (this.splitPace.seconds >= -9 && this.splitPace.seconds <= 9) {
      return "0" + this.splitPace.seconds.toString();
    }
    return this.splitPace.seconds.toString();
  }
  get splitPaceMinutesString(): string {
    if (this.splitPace.hours == 0) {
      return this.splitPace.minutes.toString();
    } else if (this.splitPace.minutes >= -9 && this.splitPace.minutes <= 9) {
      return "0" + this.splitPace.minutes.toString();
    }
    return this.splitPace.minutes.toString();
  }

  get distance(): number {
    return this.priv_distance;
  }
  set distance(distance: number) {
    this.priv_distance = distance;
    this.updatePace();
  }

  get distanceUnit(): number {
    return this.priv_distanceUnit;
  }

  set distanceUnit(distanceUnit: number) {
    this.priv_distanceUnit = distanceUnit;
    this.updatePace();
  }

  get timeMinutes(): number {
    return this.time.minutes;
  }
  set timeMinutes(timeMinutes: number) {
    if (timeMinutes < 60 && timeMinutes >= 0) {
      this.time.minutes = timeMinutes;
    } else {
      this.time.minutes = 59;
    }
    this.updatePace();
  }
  get paceUnit(): number {
    return this.priv_paceUnit;
  }
  set paceUnit(paceUnit: number) {
    this.priv_paceUnit = paceUnit;
    this.updateTime();
  }
  get timeSeconds(): number {
    return this.time.seconds;
  }
  set timeSeconds(timeSeconds: number) {
    if (timeSeconds < 60 && timeSeconds >= 0) {
      this.time.seconds = timeSeconds;
    } else {
      this.time.seconds = 59;
    }
    this.updatePace();
  }
  get timeHours(): number {
    return this.time.hours;
  }
  set timeHours(timeHours: number) {
    this.time.hours = timeHours;
    this.updatePace();
  }
  get paceSeconds(): number {
    return this.pace.seconds;
  }
  set paceSeconds(paceSeconds: number) {
    this.pace.seconds = paceSeconds;
    this.updateTime();
  }
  get paceMinutes(): number {
    return this.pace.minutes;
  }
  set paceMinutes(paceMinutes: number) {
    this.pace.minutes = paceMinutes;
    this.updateTime();
  }
  /*   get paceHours(): number {
    return this.pace.hours;
  }
  set paceHours(paceHours: number) {
    this.pace.hours = paceHours;
  } */

  updatePace(): void {
    if (this.distance == 0) {
      this.pace = timeUtil.getTimeFromSecsWithoutHours(0, true);
      return;
    }
    const totalSecondsTime =
      this.time.hours * 3600 + this.time.minutes * 60 + this.time.seconds;
    const totalDistance = this.distance * this.distanceUnit;
    const totalPace = (totalSecondsTime / totalDistance) * this.paceUnit;

    this.pace = timeUtil.getTimeFromSecsWithoutHours(totalPace, true);
    this.updateSplitpace();
  }
  updateTime(): void {
    const totalDistance = this.distance * this.distanceUnit;
    const totalPace =
      (this.pace.hours * 3600 + this.pace.minutes * 60 + this.pace.seconds) /
      this.paceUnit;

    const totalSecondsTime = totalPace * totalDistance;
    console.log(totalSecondsTime);
    this.time = timeUtil.getTimeFromSecs(totalSecondsTime, true);
    this.updateSplitpace();
  }

  updateSplitpace(): void {
    const totalPace =
      (this.pace.hours * 3600 + this.pace.minutes * 60 + this.pace.seconds) /
      this.paceUnit;

    const totalSplitTime = totalPace * (this.splitDistance * this.splitUnit);

    this.splitPace = timeUtil.getTimeFromSecs(totalSplitTime, true);
    this.updateSplitsArray();
  }

  updateSplitsArray(): void {
    if (!this.shouldDisplayTable) {
      this.distArray = [0];
      this.timeArray = [{ hours: 0, minutes: 0, seconds: 0 }];
      return;
    }

    if (
      (this.distance * this.distanceUnit) /
        (this.splitDistance * this.splitUnit) >
      100
    ) {
      this.tableHasTooManyRows = true;
      this.distArray = [];
      this.timeArray = [];
      return;
    }
    this.tableHasTooManyRows = false;
    this.distArray = [];
    this.timeArray = [];
    let totalSplitDistance = this.splitDistance * this.splitUnit;
    let totalDistance = this.distance * this.distanceUnit;
    let distanceDone = 0;

    let totalTime =
      this.time.hours * 3600 + this.time.minutes * 60 + this.time.seconds;
    let timeDone = 0;
    while (distanceDone < this.distance * this.distanceUnit) {
      let distanceLeft = totalDistance - distanceDone;
      /* let timeLeft = totalTime - timeDone; */
      if (distanceLeft < totalSplitDistance) {
        distanceDone += distanceLeft;
        this.distArray.push(timeUtil.roundToTwo(distanceDone / this.splitUnit));
        timeDone = totalTime * (distanceDone / totalDistance);
        this.timeArray.push(timeUtil.getTimeFromSecs(timeDone, true));
      } else {
        distanceDone += totalSplitDistance;
        this.distArray.push(timeUtil.roundToTwo(distanceDone / this.splitUnit));
        timeDone = totalTime * (distanceDone / totalDistance);
        this.timeArray.push(timeUtil.getTimeFromSecs(timeDone, true));
      }
      console.log(distanceDone / this.splitUnit);
    }
  }
}
